import { Controller } from "@hotwired/stimulus"
import Clipboard from "@stimulus-components/clipboard"

export default class extends Clipboard {
  static values = {
    successContent: String,
    successDuration: { type: Number, default: 2000 }
  }

  copy(event) {
    event.preventDefault()

    const button = this.buttonTarget
    const originalContent = button.innerHTML

    // Get the text to copy
    const text = this.sourceTarget.value || this.sourceTarget.textContent

    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        this.showSuccess(button, originalContent)
      }).catch(() => {
        this.fallbackCopy(text, button, originalContent)
      })
    } else {
      this.fallbackCopy(text, button, originalContent)
    }
  }

  showSuccess(button, originalContent) {
    // Change button content to show success
    button.innerHTML = `<i class="bi bi-check me-1"></i>${this.successContentValue}`
    button.classList.remove('btn-outline-primary')
    button.classList.add('btn-success')
    button.disabled = true

    // Restore original content after duration
    setTimeout(() => {
      button.innerHTML = originalContent
      button.classList.remove('btn-success')
      button.classList.add('btn-outline-primary')
      button.disabled = false
    }, this.successDurationValue)
  }

  fallbackCopy(text, button, originalContent) {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-9999px'
    textArea.style.opacity = '0'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      document.execCommand('copy')
      this.showSuccess(button, originalContent)
    } catch (err) {
      console.error('Failed to copy text: ', err)
      alert('Failed to copy JSON')
    }

    document.body.removeChild(textArea)
  }
}